import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetTenantCarrierConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTenantCarrierConfigQuery = { __typename?: 'Query', tenantCarrierConfig?: { __typename?: 'TenantCarrierConfigDocument', tenantId: string, carrier: string } | null };

export type TenantCarrierConfigDetailsFragment = { __typename?: 'TenantCarrierConfigDocument', tenantId: string, carrier: string };

export const TenantCarrierConfigDetailsFragmentDoc = new TypedDocumentString(`
    fragment TenantCarrierConfigDetails on TenantCarrierConfigDocument {
  tenantId
  carrier
}
    `, {"fragmentName":"TenantCarrierConfigDetails"});
export const GetTenantCarrierConfigDocument = new TypedDocumentString(`
    query GetTenantCarrierConfig {
  tenantCarrierConfig {
    ...TenantCarrierConfigDetails
  }
}
    fragment TenantCarrierConfigDetails on TenantCarrierConfigDocument {
  tenantId
  carrier
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetTenantCarrierConfig: build.query<GetTenantCarrierConfigQuery, GetTenantCarrierConfigQueryVariables | void>({
      query: (variables) => ({ document: GetTenantCarrierConfigDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetTenantCarrierConfigQuery, useLazyGetTenantCarrierConfigQuery } = injectedRtkApi;
